module.exports = __webpack_public_path__ + "static/media/David_Lee.14a7fa95.png";